import { Permission } from '@/lib/permissions/v1'
import { Route } from '@/composables/route'

export enum CompanyArticleRouteName {
    Index = 'customers.articles.index',
    Create = 'customers.articles.create',
    Edit = 'customers.articles.edit',
    Show = 'customers.articles.show',
    TempIndex = 'customers.articles.templates.index',
    TempCreate = 'customers.articles.templates.create',
    TempEdit = 'customers.articles.templates.edit',
}

export const setRouteQueries = async (route: Route) => {
    const { type_id } = route.query.value

    if (type_id) {
        await route.addFilter({
            column: 'type_uuid',
            operator: '=',
            value: type_id,
        })
    }

    await route.addSortItem({
        column: 'title',
        direction: 'asc',
    })

    route.setLimit(100)
}

export default {
    path: 'articles',
    component: () => import('@/views/company/article/Layout.vue'),
    meta: {
        label: 'Articles',
    },
    children: [
        {
            path: '',
            name: CompanyArticleRouteName.Index,
            component: () => import('@/views/company/article/Index.vue'),
            meta: {
                label: 'Articles',
                auth: true,
                permission: Permission.ArticleView,
            },
        },
        {
            path: 'create',
            name: CompanyArticleRouteName.Create,
            component: () => import('@/views/article/Create.vue'),
            meta: {
                label: 'Create Article',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: ':articleUuid/edit',
            name: CompanyArticleRouteName.Edit,
            component: () => import('@/views/article/Create.vue'),
            meta: {
                label: 'Edit Article',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: ':articleUuid/details',
            name: CompanyArticleRouteName.Show,
            component: () => import('@/views/company/article/Index.vue'),
            meta: {
                label: 'Show Article',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: 'templates',
            name: CompanyArticleRouteName.TempIndex,
            component: () => import('@/views/company/article/Index.vue'),
            meta: {
                label: 'Article Templates',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: 'templates/create',
            name: CompanyArticleRouteName.TempCreate,
            component: () => import('@/views/company/article/Index.vue'),
            meta: {
                label: 'Create Article Templates',
                auth: true,
                permission: 'manage-articles',
            },
        },
        {
            path: 'templates/:articleTemplateId/edit',
            name: CompanyArticleRouteName.TempEdit,
            component: () => import('@/views/company/article/Index.vue'),
            meta: {
                label: 'Edit Article Template',
                auth: true,
                permission: 'manage-articles',
            },
        },
    ],
}
